__webpack_require__.p = "/React-mini-projects/simple-live/";